import { Nothing } from 'monet';
import { remoteDataToMaybe } from '../../../lib';

const getReceivedAt = remoteAnalysis => {
  if (remoteAnalysis.isSuccess()) {
    return remoteDataToMaybe(remoteAnalysis).flatMap(analysis => analysis.receivedAt);
  }
  return Nothing();
};

export default getReceivedAt;
